import React from 'react'
import { FaTelegramPlane, FaTwitter, FaInstagramSquare, FaYoutube } from "react-icons/fa";

const DashBoardFooter = () => {
  return (
    <>
      <div className='bg-black py-3 md:hidden lg:hidden'>
      <div className=' md:flex md:justify-around grid grid-rows-2  md:items-center text-white gap-3'>
        <div className='text-gray-400 text-center md:text-start'>
          <p>© 2024 All Rights Reserved</p>
          <p>Disclaimer</p>
        </div>
        <div className='flex items-center mx-auto gap-8'>
          <p className=' rounded-full p-3 bg-black cursor-pointer hover:bg-gray-600'><FaTelegramPlane /></p>
          <p className=' rounded-full p-3 bg-black cursor-pointer hover:bg-gray-600'><FaTwitter /></p>
          <p className=' rounded-full p-3 bg-black cursor-pointer hover:bg-gray-600'><FaInstagramSquare /></p>
          <p className=' rounded-full p-3 bg-black cursor-pointer hover:bg-gray-600'><FaYoutube /></p>
        </div>
      </div>
      </div>
    </>
  )
}

export default DashBoardFooter